// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: bz99yg430Et

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicTwitterImages.module.css"; // plasmic-import: bz99yg430Et/css

createPlasmicElementProxy;

export type PlasmicTwitterImages__VariantMembers = {
  imageCount: "many" | "_3" | "_2" | "_1" | "_0";
  size: "grid" | "list";
};
export type PlasmicTwitterImages__VariantsArgs = {
  imageCount?: SingleChoiceArg<"many" | "_3" | "_2" | "_1" | "_0">;
  size?: SingleChoiceArg<"grid" | "list">;
};
type VariantPropType = keyof PlasmicTwitterImages__VariantsArgs;
export const PlasmicTwitterImages__VariantProps = new Array<VariantPropType>(
  "imageCount",
  "size"
);

export type PlasmicTwitterImages__ArgsType = {
  uploadedImages?: any;
};
type ArgPropType = keyof PlasmicTwitterImages__ArgsType;
export const PlasmicTwitterImages__ArgProps = new Array<ArgPropType>(
  "uploadedImages"
);

export type PlasmicTwitterImages__OverridesType = {
  root?: p.Flex<"div">;
  repeatImageContainer?: p.Flex<"div">;
  img?: p.Flex<typeof p.PlasmicImg>;
  image1?: p.Flex<typeof p.PlasmicImg>;
  image2?: p.Flex<typeof p.PlasmicImg>;
  image3?: p.Flex<typeof p.PlasmicImg>;
};

export interface DefaultTwitterImagesProps {
  uploadedImages?: any;
  imageCount?: SingleChoiceArg<"many" | "_3" | "_2" | "_1" | "_0">;
  size?: SingleChoiceArg<"grid" | "list">;
  className?: string;
}

const $$ = {};

function PlasmicTwitterImages__RenderFunc(props: {
  variants: PlasmicTwitterImages__VariantsArgs;
  args: PlasmicTwitterImages__ArgsType;
  overrides: PlasmicTwitterImages__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          uploadedImages: [
            "https://cdn.pixabay.com/photo/2015/10/12/15/41/kayak-984566_1280.jpg",
            "https://c2.staticflickr.com/9/8817/28973449265_07e3aa5d2e_n.jpg",
            "https://www.fillmurray.com/200/300",
            "https://www.fillmurray.com/250/380",
            "https://www.fillmurray.com/400/600",
            "https://www.fillmurray.com/240/380"
          ]
        },
        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "imageCount",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.imageCount
      },
      {
        path: "size",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.size
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootimageCount__0]: hasVariant($state, "imageCount", "_0"),
          [sty.rootimageCount__3]: hasVariant($state, "imageCount", "_3"),
          [sty.rootsize_list]: hasVariant($state, "size", "list")
        }
      )}
    >
      {(
        hasVariant($state, "imageCount", "_0")
          ? false
          : hasVariant($state, "imageCount", "_3")
          ? false
          : true
      ) ? (
        <div
          data-plasmic-name={"repeatImageContainer"}
          data-plasmic-override={overrides.repeatImageContainer}
          className={classNames(projectcss.all, sty.repeatImageContainer, {
            [sty.repeatImageContainerimageCount__0]: hasVariant(
              $state,
              "imageCount",
              "_0"
            ),
            [sty.repeatImageContainerimageCount__2]: hasVariant(
              $state,
              "imageCount",
              "_2"
            ),
            [sty.repeatImageContainerimageCount__3]: hasVariant(
              $state,
              "imageCount",
              "_3"
            ),
            [sty.repeatImageContainerimageCount_many]: hasVariant(
              $state,
              "imageCount",
              "many"
            ),
            [sty.repeatImageContainersize_list]: hasVariant(
              $state,
              "size",
              "list"
            )
          })}
        >
          {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
            (() => {
              try {
                return $props.uploadedImages;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()
          ).map((__plasmic_item_0, __plasmic_idx_0) => {
            const currentItem = __plasmic_item_0;
            const currentIndex = __plasmic_idx_0;
            return (
              <p.PlasmicImg
                data-plasmic-name={"img"}
                data-plasmic-override={overrides.img}
                alt={""}
                className={classNames(sty.img, {
                  [sty.imgglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  ),
                  [sty.imgimageCount__0]: hasVariant(
                    $state,
                    "imageCount",
                    "_0"
                  ),
                  [sty.imgimageCount__1]: hasVariant(
                    $state,
                    "imageCount",
                    "_1"
                  ),
                  [sty.imgimageCount__2]: hasVariant(
                    $state,
                    "imageCount",
                    "_2"
                  ),
                  [sty.imgimageCount__3]: hasVariant(
                    $state,
                    "imageCount",
                    "_3"
                  ),
                  [sty.imgimageCount_many]: hasVariant(
                    $state,
                    "imageCount",
                    "many"
                  ),
                  [sty.imgsize_list]: hasVariant($state, "size", "list")
                })}
                displayHeight={"100%"}
                displayMaxHeight={
                  hasVariant($state, "imageCount", "_1")
                    ? "none"
                    : hasVariant($state, "imageCount", "_2")
                    ? "none"
                    : "50%"
                }
                displayMaxWidth={
                  hasVariant($state, "imageCount", "_1") ? "none" : "50%"
                }
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"100%"}
                key={currentIndex}
                loader={"plasmic"}
                loading={"lazy"}
                src={(() => {
                  try {
                    return currentItem;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              />
            );
          })}
        </div>
      ) : null}
      <div
        className={classNames(projectcss.all, sty.freeBox__ieLys, {
          [sty.freeBoximageCount__3__ieLysSaXgy]: hasVariant(
            $state,
            "imageCount",
            "_3"
          )
        })}
      >
        <div
          className={classNames(projectcss.all, sty.freeBox__krVh, {
            [sty.freeBoximageCount__3__krVhSaXgy]: hasVariant(
              $state,
              "imageCount",
              "_3"
            )
          })}
        >
          {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
            (() => {
              try {
                return [$props.uploadedImages[0]];
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()
          ).map((__plasmic_item_0, __plasmic_idx_0) => {
            const currentItem = __plasmic_item_0;
            const currentIndex = __plasmic_idx_0;
            return (
              <p.PlasmicImg
                data-plasmic-name={"image1"}
                data-plasmic-override={overrides.image1}
                alt={""}
                className={classNames(sty.image1, {
                  [sty.image1imageCount__3]: hasVariant(
                    $state,
                    "imageCount",
                    "_3"
                  )
                })}
                displayHeight={"50%"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"auto"}
                key={currentIndex}
                loader={"plasmic"}
                loading={"lazy"}
              />
            );
          })}
          <p.PlasmicImg
            data-plasmic-name={"image2"}
            data-plasmic-override={overrides.image2}
            alt={""}
            className={classNames(sty.image2, {
              [sty.image2imageCount__3]: hasVariant($state, "imageCount", "_3")
            })}
            displayHeight={"50%"}
            displayMaxHeight={"none"}
            displayMaxWidth={"100%"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loader={"plasmic"}
            loading={"lazy"}
          />
        </div>
        <div
          className={classNames(projectcss.all, sty.freeBox__g0DE4, {
            [sty.freeBoximageCount__3__g0DE4SaXgy]: hasVariant(
              $state,
              "imageCount",
              "_3"
            )
          })}
        >
          <p.PlasmicImg
            data-plasmic-name={"image3"}
            data-plasmic-override={overrides.image3}
            alt={""}
            className={classNames(sty.image3, {
              [sty.image3imageCount__3]: hasVariant($state, "imageCount", "_3")
            })}
            displayHeight={"100%"}
            displayMaxHeight={"none"}
            displayMaxWidth={"none"}
            displayMinHeight={"0"}
            displayMinWidth={"0"}
            displayWidth={"auto"}
            loader={"plasmic"}
            loading={"lazy"}
          />
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "repeatImageContainer", "img", "image1", "image2", "image3"],
  repeatImageContainer: ["repeatImageContainer", "img"],
  img: ["img"],
  image1: ["image1"],
  image2: ["image2"],
  image3: ["image3"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  repeatImageContainer: "div";
  img: typeof p.PlasmicImg;
  image1: typeof p.PlasmicImg;
  image2: typeof p.PlasmicImg;
  image3: typeof p.PlasmicImg;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTwitterImages__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTwitterImages__VariantsArgs;
    args?: PlasmicTwitterImages__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicTwitterImages__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicTwitterImages__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTwitterImages__ArgProps,
          internalVariantPropNames: PlasmicTwitterImages__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTwitterImages__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTwitterImages";
  } else {
    func.displayName = `PlasmicTwitterImages.${nodeName}`;
  }
  return func;
}

export const PlasmicTwitterImages = Object.assign(
  // Top-level PlasmicTwitterImages renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    repeatImageContainer: makeNodeComponent("repeatImageContainer"),
    img: makeNodeComponent("img"),
    image1: makeNodeComponent("image1"),
    image2: makeNodeComponent("image2"),
    image3: makeNodeComponent("image3"),

    // Metadata about props expected for PlasmicTwitterImages
    internalVariantProps: PlasmicTwitterImages__VariantProps,
    internalArgProps: PlasmicTwitterImages__ArgProps
  }
);

export default PlasmicTwitterImages;
/* prettier-ignore-end */
